export default __webpack_public_path__ + "static/media/IMG_0279.3081a9d1.3081a9d1.JPG";